/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/*========= MENU ==================*/

export default [
  {
    url: "/dashBoard",
    name: "Dashboard",
    icon: "HomeIcon",
    i18n: "Dashboard",
  },
  {
    url: "/usuarios",
    name: "Usuários",
    i18n: "Usuários",
    icon: "UserIcon",
  },
  {
    url: "/afiliados",
    name: "Afiliados",
    i18n: "Afiliados",
    icon: "UsersIcon",
  },
  {
    url: "/encomendas",
    name: "Encomendas",
    i18n: "Encomendas",
    icon: "PackageIcon",
  },
  {
    url: "/bling",
    name: "Bling",
    i18n: "Bling",
    icon: "PackageIcon",
  },

  /* {
    url: null,
    name: "Financeiro",
    i18n: "MenuLevel2p2",
    icon: "DollarSignIcon",

    submenu: [
      {
        url: "/painelFinanceiro",
        name: "Painel Financeiro",
        i18n: "Painel Financeiro",

      },
    ],
  },
 ========= MENU ADMINISTRADOR ==================*/
  {
    header: "Administrador",
    i18n: "Apps",
  },
  /*=---------- CADASTRO  ----------=*/
  {
    url: null,
    name: "Cadastros",
    i18n: "MenuLevel2p2",
    icon: "PlusSquareIcon",

    submenu: [
      {
        url: "/produtos",
        name: "Produtos",
        i18n: "Produtos",
      },
      {
        url: "/shopping",
        name: "Shopping",
        i18n: "Shopping",
      },
      {
        url: "/tiposCaixas",
        name: "Tipos de Caixas",
        i18n: "Tipos de Caixas",
      },
      {
        url: "/tagsEncomendas",
        name: "Tags de Encomenda",
        i18n: "Tags de Encomenda",
      },
      {
        url: "/marcasPersonalidades",
        name: "Marcas e Personalidades",
        i18n: "Marcas e Personalidades",
      },
      {
        url: "/caixas",
        name: "Caixas",
        i18n: "Caixas",
      },
      {
        url: "/carteiras",
        name: "Carteiras de Cobrança",
        i18n: "Carteiras de Cobrança",
      },
      {
        url: "/cupoms",
        name: "Cupoms",
        i18n: "Cupoms",
      },
      {
        url: "/tabelasFrete",
        name: "Tabela de Frete",
        i18n: "Tabela de Frete",
      },
    ],
  },
  {
    url: null,
    name: "Configurações",
    i18n: "MenuLevel2p2",
    icon: "SettingsIcon",

    submenu: [
      {
        url: "/empresas",
        name: "Empresa",
        i18n: "Empresa",
      },
      {
        url: "/textos",
        name: "Textos",
        i18n: "Textos",
      },
      {
        url: "/banners",
        name: "Banners",
        i18n: "Banners",
      },
      {
        url: "/faq",
        name: "Faq",
        i18n: "Faq",
      },
      /*{
        url: "/mensageria",
        name: "Mensageria",
        i18n: "Mensageria",

      },*/
    ],
  },
];
